import { Slider } from './slider';

export class Carousel extends Slider {
	constructor(root, itemsNum, photoClass) {
		super(root, itemsNum, photoClass);
		this.init();
	}
}

